import { httpCreate } from './http';

const http = httpCreate('/srv/activity-documents');

export const activityDocuments = {
	//创建文档开启转吗
	/**
	 * @param { Number } id 直播间id
	 * @param { String } data.originName 上传文件名称
	 * @param { String } data.originPath 上传文件完整路径
	 * @param { String } data.originType 上传文件类型，默认截取Path后缀
	 */
	createDocuments(id, menuId, data) {
		if (!menuId) {
			menuId = 0;
		}
		return http.post(`/activity/${id}/${menuId}`, data);
	},
	//获取文档转码状态
	getDocumentsStatus(documentId) {
		return http.get(`/${documentId}/status`);
	},
	//获取文档图片集
	getDocumentsPic(documentId) {
		return http.get(`/${documentId}`);
	},
	//获取直播间文档列表
	getDocumentsList(activityId, menuId) {
		if (!menuId) {
			menuId = 0;
		}
		return http.get(`/list/${activityId}/${menuId}`);
	},
	sortDocumentsList(activityId, menuId = 0, data) {
		return http.post(`/sort/${activityId}/${menuId}`, data);
	},
	//删除文档
	delDocument(documentId) {
		return http.delete(`${documentId}`);
	},
	// 开启文档演示 //换文档
	docShow(documentId, pageNum) {
		return http.put(`/${documentId}/show/${pageNum}`);
	},
	// 翻页
	changePage(documentId, pageNum) {
		return http.put(`/${documentId}/turn/${pageNum}`);
	},
	// 退出直播间文档演示
	closeShowDoc(documentId) {
		return http.put(`/${documentId}/close`);
	},
	// 获取正在直播的文档信息
	getShowInfo(activityId) {
		return http.get(`/showing/${activityId}`);
	},
};
